import { Base } from "../../../../../base/components/base"
import { IMAGES } from "../../../../../configs/images"
import services from "../../../../../services"
import { RateToCadHeader } from "../../rate-table/rate-tocad-header"
import { RateTrToCad } from "../../rate-table/rate-tr-tocad"
import { Loading } from "../../shared/loading"
import { submitButton } from "../../shared/submit-button"
import { Tab } from "../tab"


export const ToCadTab = () => {
    const base = Tab('tocad')

    const table = Base('table')
    table.cssClass({ direction: 'ltr', borderSpacing: '0', width: '500px', })
    base.append(table)

    const header = RateToCadHeader()
    table.append(header)

    const allowed_cash = [
        'usd_buy_cad',
        'usd_sell_cad',
        'eur_buy_cad',
        'eur_sell_cad',
        'gbp_buy_cad',
        'gbp_sell_cad',
        'usdt_buy_cad',
        'usdt_sell_cad'
    ]

    const loading = Loading()
    base.append(loading)

    let pairs: any[] = [
        { title: 'USD Cash', icon: IMAGES.ICONS.USD_FLAG, prices: [] },
        { title: 'EUR Cash', icon: IMAGES.ICONS.EURO_FLAG, prices: [] },
        { title: 'GBP Cash', icon: IMAGES.ICONS.POUND_FLAG, prices: [] },
        { title: 'USDT', icon: IMAGES.ICONS.TETHER_FLAG, prices: [] }
    ]
    let rows: any[] = []
    services.rates.getRates().then(rates => {
        loading.remove()

        allowed_cash.forEach((key, index) => {
            const _index = Math.floor(index / 2)
            const found = rates.find(rate => rate.key === key)
            pairs[_index].prices.push(found)
        })

        pairs.forEach((rate,) => {
            const row = RateTrToCad(rate)
            rows.push(row)
            table.append(row)
        })

        const bigButton = submitButton()
        bigButton.enable()
        const row2 = RateTrToCad()
        row2.style({ height: '80px', borderTop: '1px solid #ccc', padding: '10px' })
        row2.append(bigButton)
        table.append(row2)

        bigButton.el.onclick =  async () => {
            const values = rows.flat().map(row => row.getValue()).flat()
            console.log('values:', values);

            const toUpdate = values.filter(row => {
                if (row.changed === false) return false
                if (row.meta.db === false) return false
                return true
            })
            console.log('toUpdate:', toUpdate);


            bigButton.disable()
            bigButton.el.innerText = 'در حال به روز رسانی...'

            for (const item of toUpdate) {
                try {
                    await services.rates.updateRate({ item: item.value, change: item.value.change, telegramShouldUpdate: false, details: item.value.details, title: item.value.title })
                } catch (error) {
                    console.log('error:', error)
                }
            }

            bigButton.el.innerText = 'اطلاعات به روز شد'
            setTimeout(() => {
                bigButton.el.innerText = 'به روز رسانی اطلاعات'
                bigButton.enable()
            }, 1000);
        }

    })

    return base
}